<template lang="pug">
    .conteudo
        .linha(style='margin: 0px')
            .coluna
                title-component(:label='$route.meta.titulo')

        .linha(style='margin-top: 0px')
            .coluna
                breadcrumb-component(:list="analiseProcesso")

        .linha(style="margin-top: 16px; justify-content: center;")
            .coluna(style="width: 100%;")
                .abas-container
                    el-tabs(
                        v-model="activeTab"
                        class="custom-tabs"
                    )
                        el-tab-pane(label="Vinculados aos técnicos para análise" name="tab1")
                        el-tab-pane(label="Vinculados ao Gerente Operacional" name="tab2")

                    div.tab-content
                        div(v-show="activeTab === 'tab1'")
                            filtro-component(
                                v-if="filtroCarregado"
                                :municipios="municipios"
                                :tecnicos="tecnicos"
                                :mostrarFaseProcesso="mostrarFaseProcessoFiltro"
                                @filtro:pesquisar="pesquisarDesvincular($event, false)"
                                @filtro:limpar="limparDesvincular"
                            )
                            .linha(style='padding-top: 20px')
                                b Listagem de Processos
                            .linha(style='padding-top: 20px')
                                analise-vinculo-table-component(
                                    class="tab-1"
                                    :headers="headersFiltradosDes"
                                    :data="paginacaoDesvincular.processos"
                                    :paginacao="paginacaoDesvincular"
                                    :is-loading="isLoadingDesvincular"
                                    :mostrarFaseProcesso='mostrarFaseProcessoFiltro',
                                    @inbox:page-change="checkPaginationChangeDes($event)"
                                    @inbox:pagination='getPaginationDes($event)'
                                ) 

                        div(v-show="activeTab === 'tab2'")
                            filtro-component(
                                v-if="filtroCarregado"
                                :municipios="municipios"
                                :mostrar-condicao="false"
                                :mostrarFaseProcesso="mostrarFaseProcessoFiltro"
                                @filtro:pesquisar="pesquisar($event, false)"
                                @filtro:limpar="limpar"
                            )
                            .linha(style='padding-top: 20px')
                                b Listagem de Processos
                            .linha(style='padding-top: 20px')
                                caixa-entrada-table-component(
                                    class="tab-2"
                                    :headers='headersFiltrados',
                                    :data='paginacao.processos',
                                    :paginacao='paginacao',
                                    :is-loading='isLoading',
                                    :mostrarFaseProcesso='mostrarFaseProcessoFiltro',
                                    @inbox:page-change='checkPaginationChange($event)',
                                    @inbox:pagination='getPagination($event)'
                                ) 
</template>

<script>
import FiltroComponent from "@/views/analiseVinculo/components/FiltroComponent.vue";
import CaixaEntradaTableComponent from "@/views/caixaEntrada/components/CaixaEntradaTable.vue";
import AnaliseVinculoTableComponent from "@/views/analiseVinculo/components/AnaliseVinculoTable.vue";
import {
  listarMunicipiosDisponiveis,
  listarPageCaixaEntradaGO,
  listarPageDesvincular,
} from "@/services/processo.service";
import { analiseProcesso } from "@/utils/breadcrumb.utils";
import { listarTecnicosDisponiveis } from "@/services/usuario.service";
export default {
  name: "AnaliseVinculoComponent",
  components: {
    FiltroComponent,
    CaixaEntradaTableComponent,
    AnaliseVinculoTableComponent,
  },
  data() {
    return {
      analiseProcesso: analiseProcesso,
      activeTab: "tab1",
      filtroCarregado: false,
      filtro: {},
      municipios: [],
      headers: [
        { text: "", field: "processoSelecionado", maxWidth: "" },
        { text: "CAR", field: "codigoImovel", maxWidth: "" },
        { text: "", field: "copiarCodigoImovel", maxWidth: "" },
        { text: "Município", field: "municipio", maxWidth: "" },
        {
          text: "Envio da proposta",
          field: "dataEnvioProposta",
          maxWidth: "",
        },
        {
          text: "Área a compensar (ha)",
          field: "areaTotalCompensar",
          maxWidth: "70px",
          tooltip: "Área compensar (ha)",
        },
        {
          text: "Área a recompor (ha)",
          field: "areaTotalRecompor",
          maxWidth: "70px",
          tooltip: "Área recompor (ha)",
        },
        {
          text: "Fase do processo",
          field: "condicaoInscricao",
          maxWidth: "",
        },
        { text: "Vinculação", field: "dataVinculoTecnico", maxWidth: "" },
        { text: "Condição", field: "condicao", maxWidth: "" },
        { text: "Ações", sortable: false, field: "acao", maxWidth: "" },
      ],
      headersDes: [
        { text: "", field: "processoSelecionado", maxWidth: "" },
        { text: "Código do Imóvel", field: "codigoImovel", maxWidth: "" },
        { text: "", field: "copiarCodigoImovel", maxWidth: "" },
        { text: "Município", field: "municipio", maxWidth: "" },
        {
          text: "Envio da Proposta",
          field: "dataEnvioProposta",
          maxWidth: "",
        },
        {
          text: "Área a Compensar (ha)",
          field: "areaTotalCompensar",
          maxWidth: "70px",
          tooltip: "Área a compensar (ha)",
        },
        {
          text: "Área a Recompor (ha)",
          field: "areaTotalRecompor",
          maxWidth: "70px",
          tooltip: "Área a recompor (ha)",
        },
        {
          text: "Fase do Processo",
          field: "condicaoInscricao",
          maxWidth: "",
        },
        { text: "Vinculação", field: "tecnicosProcesso", maxWidth: "" },
        { text: "Condição", field: "condicao", maxWidth: "" },
        { text: "Ações", sortable: false, field: "acao", maxWidth: "" },
      ],
      paginacao: {
        total: 0,
        pagina: 1,
        numeroPaginas: 0,
        quantidadePagina: 10,
        processos: [],
      },
      paginacaoDesvincular: {
        total: 0,
        pagina: 1,
        numeroPaginas: 0,
        quantidadePagina: 10,
        processos: [],
      },
      isLoading: false,
      isLoadingDesvincular: false,
      showModalDesvinculacao: false,
      showModalVinculacao: false,
      processosSelecionados: [],
      tecnicos: [],
      tecnicosNomes: [],
    };
  },
  async created() {
    this.isLoading = true;
    this.isLoadingDesvincular = true;
    this.municipios = await listarMunicipiosDisponiveis();
    this.tecnicos = await listarTecnicosDisponiveis();
    this.tecnicos.sort((a, b) =>
      a.nomeRazaoSocial.localeCompare(b.nomeRazaoSocial, "pt-BR")
    );
    this.tecnicosNomes = this.tecnicos.map(
      (tecnico) => tecnico.nomeRazaoSocial
    );
    this.isLoading = false;
    this.isLoadingDesvincular = false;
    this.filtroCarregado = true;
  },
  watch: {
    activeTab(newTab) {
      if (newTab === "tab1") {
        this.pesquisarDesvincular(this.filtro);
      } else if (newTab === "tab2") {
        this.pesquisar(this.filtro);
      }
    },
  },
  computed: {
    mostrarFaseProcessoFiltro() {
      return this.$route.meta.mostrarFaseProcesso;
    },
    headersFiltrados() {
      return this.headers.filter((header) => {
        if (
          header.field === "condicaoInscricao" ||
          header.field === "processoSelecionado"
        ) {
          return this.mostrarFaseProcessoFiltro;
        }
        if (header.field === "dataVinculoTecnico") {
          return !this.mostrarFaseProcessoFiltro;
        }
        return true;
      });
    },
    headersFiltradosDes() {
      return this.headersDes.filter((header) => {
        if (
          header.field === "condicaoInscricao" ||
          header.field === "processoSelecionado"
        ) {
          return this.mostrarFaseProcessoFiltro;
        }
        if (
          header.field === "condicao" ||
          header.field === "processoSelecionado"
        ) {
          return this.mostrarFaseProcessoFiltro;
        }
        return true;
      });
    },
  },
  methods: {
    async pesquisar(filtro) {
      this.filtro = filtro;
      this.isLoading = true;

      try {
        this.paginacao.processos = [];

        const paginacao = await listarPageCaixaEntradaGO(filtro);

        if (paginacao.processos.length === 0) {
          this.$toast({
            showClose: true,
            message: `Sem dados para o filtro adicionado!<br/><br/>`,
            type: "success",
            dangerouslyUseHTMLString: true,
            duration: 15000,
          });
        } else {
          this.paginacao.processos = paginacao.processos.map((item) => ({
            ...item,
            selecionado: false,
          }));
        }

        this.paginacao = {
          ...this.paginacao,
          ...paginacao,
        };
      } catch (error) {
        const mensagemErro =
          error?.response?.data?.message ||
          error.message ||
          "Erro ao buscar dados.";
        this.$toast({
          showClose: true,
          message: mensagemErro,
          type: "error",
          duration: 15000,
        });
      } finally {
        this.isLoading = false;
      }
    },
    limpar() {
      const limpo = {
        total: 0,
        pagina: 1,
        numeroPaginas: 0,
        quantidadePagina: 10,
        processos: [],
      };
      this.pesquisar(limpo);
    },
    checkPaginationChangeDes(page) {
      this.pesquisarDesvincular({
        ...this.filtro,
        pagina: page,
      });
    },
    checkPaginationChange(page) {
      this.pesquisar({
        ...this.filtro,
        pagina: page,
      });
    },

    getPagination(paginationEvent) {
      return paginationEvent;
    },
    getPaginationDes(paginationEvent) {
      return paginationEvent;
    },

    async pesquisarDesvincular(filtro) {
      this.filtro = filtro;
      this.isLoading = true;

      this.paginacaoDesvincular.processos = [];

      try {
        const paginacaoDesvincular = await listarPageDesvincular(filtro);

        if (paginacaoDesvincular.processos.length === 0) {
          this.$toast({
            showClose: true,
            message: `Sem dados para o filtro adicionado!`,
            type: "success",
            duration: 15000,
          });
        } else {
          this.paginacaoDesvincular = {
            ...this.paginacaoDesvincular,
            ...paginacaoDesvincular,
            processos: paginacaoDesvincular.processos.map((item) => ({
              ...item,
              selecionado: false,
            })),
          };
        }
      } catch (error) {
        this.$toast({
          showClose: true,
          message: "Erro inesperado ao buscar dados!",
          type: "error",
          duration: 10000,
        });
      } finally {
        this.isLoadingDesvincular = false;
      }
    },

    limparDesvincular() {
      const limpo = {
        total: 0,
        pagina: 1,
        numeroPaginas: 0,
        quantidadePagina: 10,
        processos: [],
      };
      this.pesquisarDesvincular(limpo);
    },
  },
};
</script>

<style scoped>
.coluna {
  padding: 8px;
}

.tab-content {
  width: 100%;
  margin-top: 16px;
}

.tab-1 {
  width: 100%;
}

.tab-2 {
  width: 100%;
}

.linha {
  display: flex;
  width: 100%;
  margin-bottom: 0px;
  align-items: center;
}

.tabs-container {
  text-align: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.button-container .el-button {
  font-size: 14px;
  padding: 8px 16px;
  background-color: var(--primary-green);
  color: white;
}

.abas-container {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 16px;
  background-color: var(--primary-background);
  width: 100%;
  box-sizing: border-box;
  margin-top: 16px;
}

.custom-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.custom-tabs .el-tabs__item {
  font-weight: bold;
  color: #333;
  padding: 12px 16px;
}

.custom-tabs .el-tabs__item.is-active {
  color: #28a745 !important;
  border-bottom: 2px solid #28a745 !important;
}
</style>
